import { Navigate, useParams } from "react-router";

/**
 * Slack alerts sent before 2026-09-29 linked to /admin/support/tickets/:id, which is not a web route and fell
 * through to the workspace navigator (payout page). Keep those already-posted links working.
 */
export function LegacySupportTicketRedirect() {
  const { id } = useParams();
  return <Navigate to={id ? `/admin/support/${encodeURIComponent(id)}` : "/admin/support"} replace />;
}
